import React from 'react'
import { Building2, Bed } from 'lucide-react'

interface PortfolioHeroProps {
  today: string
  currentUser: { id: number; email: string }
  activeProperties: number
  totalRooms: number
}

function greeting(date: Date): string {
  const hour = date.getHours()
  if (hour < 5) return 'A late night'
  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  if (hour < 22) return 'Good evening'
  return 'A late night'
}

export default function PortfolioHero({
  today,
  currentUser,
  activeProperties,
  totalRooms,
}: PortfolioHeroProps) {
  const date = new Date(today + 'T00:00:00')
  const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' })
  const dayMonth = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' })
  const year = date.getFullYear()
  const firstName = currentUser.email
    .split('@')[0]
    .split('.')[0]
    .replace(/^./, (c) => c.toUpperCase())
  const greet = greeting(new Date())

  return (
    <div className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end">
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
          {greet}, {firstName} · {weekday}
        </div>
        <h1 className="mt-3 font-light tracking-tight text-foreground">
          <span className="block text-5xl leading-[1.05] sm:text-6xl">{dayMonth}</span>
          <span className="mt-1 block text-2xl italic text-muted-foreground sm:text-3xl">
            {year} · A view across the portfolio
          </span>
        </h1>
      </div>

      <div className="flex items-center gap-8 lg:justify-end">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            Hotels
          </div>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-3xl font-semibold tabular-nums text-foreground">{activeProperties}</span>
            <Building2 className="h-4 w-4 text-muted-foreground/60" />
          </div>
        </div>
        <div className="h-12 w-px bg-border" />
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            Rooms
          </div>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-3xl font-semibold tabular-nums text-foreground">{totalRooms}</span>
            <Bed className="h-4 w-4 text-muted-foreground/60" />
          </div>
        </div>
      </div>
    </div>
  )
}
